import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentsFacade, DocumentsFilter } from './documents.facade';
import { DocumentResourceV4 } from '@models/resources/document.model';
import { environment } from '../../../../environments/environment';

/**
 * HTTP-Variante (Sprint 5c S5c-8 + V4-Refactor S5c-12). Active when
 * `environment.dataSource === 'http'`.
 *
 * Wire-Contract (V4):
 * - `GET /api/me/documents` → `DocumentResourceV4[]` (serverseitig
 *   gefiltert auf `visible_to_customer=true` + eigener `customer_id`)
 * - `GET /api/documents/{id}/download` → Binary-Blob (Streaming via
 *   `Storage::disk('documents')->response()`)
 *
 * Filter (`search`/`classification`) werden als Query-Params an
 * `/me/documents` durchgereicht. S5c-12 aligned das endgültige Schema —
 * bis dahin pass-through.
 */
@Injectable()
export class HttpDocumentsFacade implements DocumentsFacade {
  private readonly http = inject(HttpClient);

  list(filter?: DocumentsFilter): Observable<DocumentResourceV4[]> {
    // Sprint-5c-Review-Folge-Fix: BE liest `?type=` (matched
    // `EDocumentType`-Enum-Wert). FE-Filter heißt intern weiter
    // `classification` (V3-FE-Modell-Kompat), wird beim Wire-Hop in
    // `type` umbenannt.
    let params = new HttpParams();
    if (filter?.search) {
      params = params.set('search', filter.search);
    }
    if (filter?.classification && filter.classification !== 'all') {
      params = params.set('type', filter.classification);
    }
    return this.http.get<DocumentResourceV4[]>(`${environment.apiUrl}/me/documents`, {
      params,
    });
  }

  download(id: number): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/documents/${id}/download`, {
      responseType: 'blob',
    });
  }
}
